import { render, staticRenderFns } from "./Cols-50-50.vue?vue&type=template&id=db16b0a4&scoped=true&"
import script from "./Cols-50-50.vue?vue&type=script&lang=js&"
export * from "./Cols-50-50.vue?vue&type=script&lang=js&"
import style0 from "./Cols-50-50.vue?vue&type=style&index=0&id=db16b0a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db16b0a4",
  null
  
)

export default component.exports